export default __webpack_public_path__ + "static/media/DennisNnamani.da133cc1.svg";